/**
 * Permanent app URLs — environment-aware.
 *
 * Behaviour:
 *   1. If REACT_APP_APP_BASE_URL is set AND it matches the browser's
 *      current origin, use it (production case — app runs on the
 *      canonical domain, links use the canonical domain).
 *   2. Otherwise, fall back to `window.location.origin`. This
 *      guarantees we NEVER surface a URL to the operator that points
 *      at a domain that isn't currently deployed / reachable.
 *
 * Rationale: an operator viewing the app on
 * `https://fuel-card-draft.preview.emergentagent.com` must NOT be told
 * "the permanent login URL is https://app.getfuelcard.com/login" until
 * that production domain is actually deployed. During the preview
 * window, the safe answer is: "use the URL you're currently on".
 *
 * Production wiring (after deploy):
 *   REACT_APP_APP_BASE_URL=https://app.getfuelcard.com
 *   APP_BASE_URL=https://app.getfuelcard.com   (backend, for emails)
 * When the app is actually served from app.getfuelcard.com, the
 * origin check passes and the canonical URL is used.
 */

const CONFIGURED = (process.env.REACT_APP_APP_BASE_URL || "").trim().replace(/\/+$/, "");

function _resolvedBase() {
  const origin = typeof window !== "undefined" && window.location
    ? window.location.origin
    : "";
  // If the env value matches the origin we're on, trust it — it's the
  // canonical production URL. Otherwise use the current origin so
  // links we surface actually resolve.
  if (CONFIGURED && origin && CONFIGURED === origin) return CONFIGURED;
  return origin || CONFIGURED; // origin is authoritative in the browser
}

// Exposed for debugging / tests.
export function appBaseUrl() {
  return _resolvedBase();
}
export const APP_BASE_URL = _resolvedBase();

const _join = (path) => {
  const base = _resolvedBase();
  if (!base) return path;
  return `${base}${path.startsWith("/") ? path : "/" + path}`;
};

export const teamLoginUrl     = () => _join("/login");
export const customerLoginUrl = () => _join("/customer/login");
export const inviteAcceptUrl  = (token) => _join(`/invite/accept?token=${encodeURIComponent(token)}`);
